import React from "react";
import { Box, Chip, Sheet, Typography } from "@mui/joy";

const MaintenancePage: React.FC = () => {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 6,
        background:
          "radial-gradient(circle at 20% 20%, rgba(12, 81, 110, 0.14) 0%, rgba(255, 255, 255, 1) 40%), #ffffff",
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          width: "100%",
          maxWidth: 620,
          borderRadius: "20px",
          px: { xs: 3, sm: 4.5 },
          py: { xs: 4, sm: 5 },
          boxShadow: "lg",
        }}
        aria-live="polite"
        aria-label="Maintenance notice"
      >
        <Chip
          color="warning"
          variant="soft"
          size="sm"
          sx={{ letterSpacing: "0.06em" }}
        >
          MAINTENANCE MODE
        </Chip>
        <Typography
          level="h1"
          sx={{ mt: 2, mb: 1, fontSize: { xs: "2rem", sm: "2.2rem" } }}
        >
          We are currently improving the platform.
        </Typography>
        <Typography
          level="body-md"
          sx={{ color: "text.secondary", lineHeight: 1.8 }}
        >
          The application is temporarily unavailable while maintenance is in
          progress. Please check back shortly.
        </Typography>
      </Sheet>
    </Box>
  );
};

export default MaintenancePage;
